// IT
export const propCreateHc = {
  firstCreate: {
    // Tipi di alloggio
    typeApartmentLabel: `Appartamento`,
    typeApartmentDesc: `Alloggio ammobiliato e indipendente affittato per intero.`,
    typeVillaLabel: `Villa o casa`,
    typeVillaDesc: `Case, ville e chalet affittati per intero.`,
    typeHotelLabel: `Hotel, ostello o B&B`,
    typeHotelDesc: `Strutture che gestiscono più camere.`,
    typeCampingLabel: `Campeggio`,
    typeCampingDesc: `Campeggi e piazzole con più posti o unità.`,

    // Sostantivi di struttura / unità
    venueHotel: `hotel`,
    venueCamping: `campeggio`,
    roomHotel: `camera`,
    roomCamping: `piazzola`,
    roomHotelPlural: `camere`,
    roomCampingPlural: `piazzole`,
    yourVenue: `il tuo {venue}`,

    // Pulsanti comuni
    back: `Indietro`,
    continue: `Continua`,

    // Passaggio: tipo
    typeTitle: `Registriamo il tuo alloggio!`,
    typeSubtitle: `Per iniziare, scegli il tipo di alloggio che vuoi pubblicare.`,

    // Passaggio: quantità
    quantityTitle: `Quanti alloggi vuoi registrare?`,
    quantitySubtitle: `Puoi iniziare con uno o crearne diversi in una volta.`,
    oneTitle: `1 alloggio`,
    oneDesc: `Per ora voglio pubblicarne solo uno.`,
    manyTitle: `Più di 1 alloggio`,
    manyDesc: `Ne ho diversi da registrare.`,

    // Passaggio: posizione (stesso edificio o no)
    locationTitle: `Si trovano nello stesso edificio o indirizzo?`,
    locationSubtitle: `Questo ci aiuta a organizzare i tuoi alloggi nel modo migliore.`,
    sameBuildingYesTitle: `Sì, nello stesso edificio o indirizzo`,
    sameBuildingYesDesc: `Saranno raggruppati in un unico annuncio con più unità.`,
    sameBuildingNoTitle: `No, in indirizzi diversi`,
    sameBuildingNoDesc: `Ognuno sarà un annuncio indipendente (lo configuri dopo).`,

    // Passaggio: nomi (titoli e sottotitoli dinamici)
    namesTitleAttach: `Aggiungi un'unità al tuo annuncio`,
    namesTitleHotel: `Come si chiama il tuo {venue}?`,
    namesTitleGrouped: `Assegna un nome a ogni unità`,
    namesTitleList: `Assegna un nome a ogni alloggio`,
    namesTitleDefault: `Come si chiama il tuo alloggio?`,
    namesSubAttach: `Sarà aggiunta come una nuova unità all'interno di “{name}”.`,
    yourListing: `il tuo annuncio`,
    namesSubHotel: `È il nome che vedranno i tuoi ospiti. Nel passaggio successivo aggiungi i tipi di {room}.`,
    namesSubGrouped: `Ogni unità avrà il proprio calendario all'interno dello stesso annuncio.`,
    namesSubList: `Ognuno sarà un annuncio indipendente con la propria configurazione.`,
    namesSubDefault: `È il nome che vedranno i tuoi ospiti. Potrai cambiarlo quando vuoi.`,
    addUnitLabel: `Aggiungi un'altra unità`,
    addListingLabel: `Aggiungi un altro alloggio`,

    // Card dell'annuncio principale (raggruppato)
    mainListingEyebrow: `Annuncio principale`,
    mainListingSub: `Raggruppa tutte le unità di questo edificio in un solo annuncio.`,
    mainListingNameLabel: `Nome dell'alloggio principale`,
    mainListingNamePlaceholder: `Es: Residencial Bilbao`,
    mainListingNameHint: `Edificio, torre o posizione che raggruppa le unità.`,
    currency: `Valuta`,
    currencyHintUnit: `Tariffa a notte di ogni unità.`,

    // Card di unità
    unitNameLabel: `Nome dell'unità`,
    listingNameLabel: `Nome dell'alloggio`,
    phRoomCamping: `Es: Camping Pinar del Mar`,
    phRoomHotel: `Es: Hotel Costa Azul`,
    phAttach: `Es: Monolocale di lusso a Playa Roca, fronte mare`,
    phGrouped: `Es: Appartamento {n}A`,
    phList: `Alloggio {n}`,
    phDefault: `Es: Appartamento Centro`,
    remove: `Rimuovi`,
    internalNameOptional: `Nome interno (facoltativo)`,
    pricePerNight: `Prezzo / notte`,
    currencyHintHotel: `Tutte le {rooms} usano questa valuta.`,

    // Nome interno (caso di nome unico)
    internalNameLabel: `Nome interno`,
    optional: `(facoltativo)`,
    internalNamePlaceholderSingle: `Es: Appartamento ristrutturato 2024 / chiavi in portineria`,
    internalNameHint: `Lo vedi solo tu, per identificarlo internamente. Non viene mostrato agli ospiti.`,

    // Passaggio: tipi di camera (hotel/campeggio)
    roomsTitle: `Quali {rooms} ha {venue}?`,
    roomsSubtitle: `Aggiungi ogni tipo di {room} con la sua quantità e il suo prezzo a notte. Potrai modificarlo quando vuoi.`,
    roomTypeLabel: `Tipo di {room}`,
    phRoomTypeCamping: `Es: Piazzola con elettricità`,
    phRoomTypeHotel: `Es: Camera doppia deluxe`,
    quantity: `Quantità`,
    addRoomType: `Aggiungi tipo di {room}`,

    // Passaggio: indirizzo
    addressTitle: `Dove si trova il tuo alloggio?`,
    addressSubtitle: `Inizia a digitare e scegli l'indirizzo. Lo usiamo per la mappa e il check-in.`,
    country: `Paese`,
    countryHint: `Cercheremo gli indirizzi solo all'interno di questo paese.`,
    address: `Indirizzo`,
    addressPlaceholder: `Via, numero, città…`,
    addressPlaceholderNoCountry: `Prima scegli il paese`,
    city: `Città`,
    zipCode: `Codice postale`,

    // Passaggio: tariffa
    priceTitle: `La tua tariffa standard a notte`,
    priceSubtitle: `È il tuo prezzo base. Poi potrai adeguarlo per stagione o per canale.`,
    priceLabel: `Prezzo a notte`,
    perNight: `/ notte`,
    priceHint: `Puoi cambiarlo quando vuoi dal pannello.`,

    // Pulsante principale e motivo della creazione
    createUnit: `Aggiungi unità`,
    createVenue: `Crea il mio {venue}`,
    createListingsPlural: `Crea il mio alloggio | Crea i miei {count} alloggi`,
    reasonUnit: `unità`,
    reasonListing: `annuncio`,

    // Toast / convalida
    toastCompleteToContinue: `Completa i dati per continuare.`,
    toastCompleteNames: `Completa il nome di ogni alloggio.`,
    toastCompleteLocation: `Completa la posizione.`,
    toastCompleteRooms: `Completa ogni camera: nome, quantità e prezzo a notte.`,
    toastRoomRatePerUnit: `Indica la tariffa a notte di ogni unità.`,
    toastCompleteRate: `Completa la tariffa a notte.`,
    toastCreatedPlural: `Alloggio creato! | Alloggi creati!`,
    toastCreateError: `Non siamo riusciti a creare l'alloggio. Riprova.`,
  },

  welcome: {
    // Titoli dell'intestazione
    arrivalTitleCaps: `Istruzioni di Arrivo`,
    arrivalTitle: `Istruzioni di arrivo`,
    arrivalSubtitle: `Messaggio che l'ospite riceve il giorno del suo arrivo.`,
    welcomeTitle: `Messaggio di benvenuto`,
    welcomeSubtitle: `Messaggio che l'ospite riceve dopo aver completato la registrazione.`,
    loadingMessages: `Caricamento dei messaggi...`,

    // Benvenuto per camera
    roomWelcomeTitle: `Messaggio di benvenuto di questa camera`,
    roomWelcomeSub: `Se lo lasci vuoto, viene inviato il messaggio di benvenuto generale dell'hotel. L'interruttore, gli allegati e l'OTA si configurano a livello di hotel.`,

    // Interruttore di benvenuto
    welcomeEnableTitle: `Invia il messaggio di benvenuto`,
    welcomeEnableSub: `L'ospite lo riceve dopo aver completato la registrazione. Se lo disattivi, non verrà inviato.`,

    // Clona
    clone: `Clona`,
    clonePullTitle: `Importa la configurazione da un altro alloggio`,
    clonePullSub: `Importa il benvenuto di un altro in questo`,
    clonePushTitle: `Copia questa configurazione in un altro alloggio`,
    clonePushSub: `Applica questo benvenuto ad altri`,
    cloneModalPullTitle: `Importa la configurazione di benvenuto`,
    cloneModalPushTitle: `Copia il messaggio di benvenuto`,
    cloneModalPullSubtitle: `Scegli l'alloggio da cui vuoi importare la configurazione. Sarà applicata a questo annuncio.`,
    cloneModalPushSubtitle: `Copia questa configurazione (testi, modalità, OTA e allegati) negli alloggi che scegli.`,
    itemNounWelcome: `il messaggio di benvenuto`,
    arrivalTitleNoun: `istruzioni di arrivo`,
    itemNounArrival: `le istruzioni di arrivo`,

    // Modalità di configurazione
    modeConfigLabel: `Modalità di configurazione`,
    modeSingleTitle: `Messaggio unico`,
    modeSingleDesc: `Tutte le unità condividono lo stesso messaggio`,
    modeActive: `Attivo`,
    modePropertyTitle: `Per proprietà`,
    modePropertyDesc: `Ogni unità ha il proprio messaggio`,
    modePropertyNotice: `Modalità individuale attiva. Modifica il messaggio da ogni proprietà.`,

    // Interruttore di arrivo
    arrivalEnableTitle: `Invia le istruzioni di arrivo`,
    arrivalAutoSend: `Vengono inviate automaticamente il giorno dell'arrivo{atTime}.`,
    arrivalAtTime: ` alle {time}`,

    // Canali / invio
    deliveryChannels: `Canali di invio`,
    channelEmail: `E-mail`,
    sendAlsoOta: `Invia anche tramite OTA`,
    sendTime: `Orario di invio`,

    // Editor
    editorSubtitle: `Configura per lingua. Suggerimento: usa emoji e testo breve.`,
    translateTitle: `Traduci da {lang} nelle altre lingue`,
    translatingLangLabel: `Traduzione di {lang}…`,
    translatingGeneric: `Traduzione…`,
    translate: `Traduci`,

    // Allegati
    uploading: `Caricamento…`,
    attach: `Allega`,
    emojis: `Emoji`,
    variables: `Variabili`,
    variablesHint: `Clicca per inserirle. Vengono sostituite con i dati reali della prenotazione all'invio.`,
    uploadDone: `Inviato. Salvataggio sul server…`,
    uploadSizeProgress: `{done} di {total} MB`,
    attachHint: `Immagini e PDF fino a {fileMb} MB · Video in MP4 fino a {videoMb} MB.`,
    whatsappLimits: `Sono i limiti consentiti da WhatsApp.`,
    openFile: `Apri {name}`,
    attachmentFallback: `allegato`,
    delete: `Elimina`,
    open: `Apri`,
    arrivalAttachments: `Allegati delle istruzioni di arrivo`,
    welcomeAttachments: `Allegati del messaggio di benvenuto`,
    attachHintFull: `Immagini e PDF fino a {fileMb} MB · video in MP4 fino a {videoMb} MB. Sono i limiti consentiti da WhatsApp.`,
    noAttachments: `Non ci sono ancora allegati.`,
    editorSubtitleProperty: `Configura per lingua e allega file (immagini, PDF, video).`,

    // Salva
    saveData: `Salva i dati`,
    saving: `Salvataggio…`,

    // Riepilogo delle serrature
    locksConfigured: `Serrature configurate`,
    accessMethodConfigured: `Metodo di accesso configurato`,
    guestAccess: `Accesso dell'ospite`,
    accessDisabledHtml: `L'invio dei codici di accesso è <strong>disattivato</strong>, non sarà incluso nelle istruzioni di arrivo.`,
    noAccessMethod: `Non è ancora configurato alcun metodo di accesso per questo alloggio.`,
    locksHint: `Si configura nella scheda «Serrature e accesso» dell'annuncio.`,

    // Anteprima
    online: `online`,
    previewDayArrival: `Giorno di arrivo`,
    previewAfterRegister: `Dopo la registrazione`,
    previewPlaceholder: `Scrivi il messaggio per vedere qui l'anteprima…`,
    previewIncludesAccess: `Include l'accesso configurato`,
    languageLabel: `lingua {lang}`,
    previewFallbackName: `Il tuo alloggio`,
    previewFallbackAccommodation: `il tuo alloggio`,

    // Riepiloghi della serratura (computed)
    lockNoteDynamic: `Una nuova chiave viene generata automaticamente a ogni prenotazione`,
    lockTagBox: `Codice della cassetta portachiavi`,
    lockTag: `Codice`,
    lockCodePending: `Codice da configurare`,
    lockCodeValue: `{tag}: {code}`,
    lockLabelDefault: `Ingresso`,

    // Messaggi di accesso dell'anteprima (computed)
    lockMsgDynamic: `🔒🔑 *{label} · {name}*\n\nIl tuo codice di accesso è: *58117*\n\nValido durante il tuo soggiorno.`,
    lockMsgBox: `🔑 *{label} · {name}*\n\nLa cassetta portachiavi si apre con il codice: *{code}*\n\nAll'interno troverai le chiavi dell'alloggio. Per favore, rimettile a posto quando esci.`,
    lockMsgStatic: `🔒🔑 *{label} · {name}*\n\nIl codice della serratura è: *{code}*\n\nUsalo per aprire la porta dell'alloggio.`,

    // Etichette delle variabili (computed)
    varGuestName: `Nome dell'ospite`,
    varFullName: `Nome completo`,
    varCheckinDate: `Data di arrivo`,
    varCheckoutDate: `Data di partenza`,
    varCheckinTime: `Orario di check-in`,
    varCheckoutTime: `Orario di check-out`,
    varNights: `Numero di notti`,
    varGuests: `Numero di ospiti`,

    // Opzioni della serratura (computed)
    lockOptBoxTitle: `Cassetta portachiavi`,
    lockOptBoxDesc: `Le chiavi sono in una cassetta portachiavi di sicurezza.`,
    lockOptDynamicTitle: `Serratura intelligente`,
    lockOptDynamicDesc: `Ogni prenotazione crea una nuova chiave automaticamente.`,
    lockOptStaticTitle: `Serratura con codice fisso`,
    lockOptStaticDesc: `Una cassetta portachiavi o una serratura con codice fisso.`,

    // Messaggio di arrivo predefinito (computed)
    defaultArrivalMessage: `🏡 *Istruzioni di arrivo*\n\nCiao *{guest}* 👋\n\nAll'arrivo, dirigiti all'ingresso principale dell'alloggio. 🔑\n\nSe hai bisogno di aiuto, scrivici su questo stesso WhatsApp 📲\n\nBuon soggiorno! ✨`,

    // Contesto proprietà (ereditato)
    inheritedChannelsTitle: `Canali ereditati dal listing`,
    inheritedListingPrefix: `Questa proprietà usa il welcome centralizzato del listing`,
    emailChannel: `Posta elettronica`,
    otaActive: `OTA attiva`,
    inheritedNote: `Se vuoi cambiare l'invio tramite OTA di questo welcome, fallo dalle impostazioni dell'annuncio/listing.`,
    propertyDeliveryTitle: `Da dove verrà inviato questo welcome?`,
    propertyDeliverySubtitle: `Configura i canali di invio per questa proprietà.`,
    propertyDeliveryNote: `Questi canali restano attivi per impostazione predefinita. Qui puoi anche aggiungere l'invio tramite OTA per questa proprietà.`,
    otaRowTitle: `Invia i messaggi di benvenuto tramite le OTA`,
    otaRowText: `Proverà a inviare il welcome di questa proprietà tramite Booking.com e Airbnb usando Channex, con i suoi allegati configurati.`,
    otaRowHint: `Viene salvato insieme al messaggio e agli allegati di benvenuto.`,

    // Toast / convalida
    toastLoadError: `Non è stato possibile caricare i messaggi.`,
    toastOtaUpdated: `Canale OTA aggiornato correttamente`,
    toastOtaError: `Non è stato possibile aggiornare l'invio tramite OTA`,
    toastSendTimeUpdated: `Orario di invio aggiornato`,
    toastSendTimeError: `Non è stato possibile salvare l'orario`,
    toastArrivalEnabled: `Istruzioni di arrivo attivate`,
    toastArrivalDisabled: `Istruzioni di arrivo disattivate`,
    toastStatusError: `Non è stato possibile aggiornare lo stato`,
    toastWelcomeEnabled: `Messaggio di benvenuto attivato`,
    toastWelcomeDisabled: `Messaggio di benvenuto disattivato`,
    toastModeUpdated: `Modalità aggiornata correttamente`,
    toastModeError: `Non è stato possibile aggiornare la modalità`,
    toastAttachUploaded: `Allegato/i caricato/i correttamente`,
    toastAttachUploadError: `Errore durante il caricamento degli allegati`,
    toastAttachDeleted: `Allegato eliminato`,
    toastAttachDeleteError: `Non è stato possibile eliminare l'allegato`,
    toastChangesSaved: `Modifiche salvate`,
    toastTranslateEmpty: `Scrivi un messaggio nella lingua attiva prima di tradurre.`,
    toastTranslateSuccess: `{count} lingue tradotte! Controlla ogni scheda prima di salvare.`,
    toastTranslatePartial: `{success} tradotte, {failed} non riuscite. Puoi riprovare.`,
    toastTranslateNone: `Non è stato possibile tradurre nessuna lingua. Riprova.`,

    // Errori di convalida dei file (WhatsApp)
    fileErrorVideoFormat: `❌ {name} è un video {ext} e WhatsApp accetta solo MP4. Convertilo in MP4 e ricaricalo.`,
    fileErrorTooBig: `❌ {name} pesa {mb} MB e il massimo è {limMb} MB. `,
    fileErrorTooBigVideo: `WhatsApp non accetta video più grandi: comprimilo o ritaglialo.`,
    fileErrorTooBigFile: `WhatsApp non accetta file più grandi.`,
  },
};
